import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import { i18n } from '../../../../language';
import { classNames } from '../../../../utils';

const useStyles = makeStyles((theme) => ({
  root: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
    color: '#7d86a9',
  },
}));

export default function Results({ length, className }) {
  const classes = useStyles();
  return (
    <Typography className={classNames(classes.root, className)}>{`${length} ${i18n.t('SETTING_RESULTS')}`}</Typography>
  );
}
